var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { cloneElement, useRef } from 'react';
import { useMergeRefs } from '../hooks';
import { iconStyle, innerContentStyle, linkStyle } from './styles';
import useIconSize from './use-icon-size';
function LinkInternal(_a, ref) {
    var as = _a.as, children = _a.children, iconLeft = _a.iconLeft, iconRight = _a.iconRight, _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'inherit' : _c, restProps = __rest(_a, ["as", "children", "iconLeft", "iconRight", "inverted", "size"]);
    var Element = as !== null && as !== void 0 ? as : 'a';
    var _d = useFocusRing(), focusProps = _d.focusProps, isFocusVisible = _d.isFocusVisible;
    var linkRef = useRef(null);
    var iconSize = useIconSize(linkRef);
    var mergedRef = useMergeRefs(linkRef, ref);
    var typedRestProps = restProps;
    function renderIcon(originalIcon) {
        return originalIcon.props.size != null
            ? originalIcon
            : cloneElement(originalIcon, {
                css: [iconStyle, originalIcon.props.css],
                size: iconSize,
            });
    }
    return (_jsxs(Element, __assign({}, mergeProps(focusProps, typedRestProps), { css: linkStyle({
            inverted: inverted,
            isFocusVisible: isFocusVisible,
            size: size,
        }), ref: mergedRef }, { children: [iconLeft != null && renderIcon(iconLeft), _jsx("span", __assign({ css: innerContentStyle({
                    hasLeftIcon: !(iconLeft == null),
                    hasRightIcon: !(iconRight == null),
                    iconSize: iconSize,
                }) }, { children: children })), iconRight != null && renderIcon(iconRight)] })));
}
export default LinkInternal;
